module.exports = __webpack_public_path__ + "static/media/WMV.11d79685.svg";